package kz.dentalcrm.app.screens.menu.mvi

import kz.dentalcrm.app.core.base.ViewEvent

sealed interface MenuViewEvent : ViewEvent {
    data object LogOut : MenuViewEvent
}
